module.exports = __webpack_public_path__ + "static/media/sunset-investing-screenshot-5.6f993b61.jpg";